<script>
// import axios from "axios";
import Layout from "../../layouts/main";
import appConfig from "@/app.config";
import PageHeader from "@/components/page-header";
import axios from 'axios'
import tableContacts from "@/components/widgets/tableContacts";
import Vue from 'vue'
import VueAxios from 'vue-axios'

import { todoMethods, todoComputed } from "@/state/helpers";

import { tableData } from "./dataAdvancedtable";

Vue.use(VueAxios, axios)

/**
 * Dashboard Component
 */
export default {
  page: {
    title: "Contactos",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },


  components: {
    Layout,
    PageHeader,
    tableContacts,
  },
  data() {
    return {

      mujeres: null,

      filters: {
      total: { value: '', keys: ['total'] }
    },
      post:[],

// ************************************** Link
      tableData: tableData,
      title: "Contactos",
      items: [
        {
          text: "Mujeres",
          href: "/Mujeres",
        },
        {
          text: "Contactos",
          active: true,
        },
      ],
    
      
      tableContacts: [
      ],
      info: null,
      showModal: false,
      isLoading: false,
      fullPage: true,
      canCancel: false,
      totalRows: 1,
      todoTotalRows: 1,
      currentPage: 1,
      todocurrentPage: 1,
      current: 1,
      perPage: 10,
      statData: 1,
      todoperPage: 10,
      pageOptions: [10, 25, 50, 100],
      todoOptions: [10, 50, 100, 150, 200],
      filter: null,
      todoFilter: null,
      filterOn: [],
      todofilterOn: [],
      sortBy: "age",
      sortDesc: false,
      useSlot: false,
      loader: "spinner",
      color: "#007bff",
      bgColor: "#FFFFFF",
      height: 128,
      width: 128,
      timeout: 3000, //ms
      fetchingStats: true,
      earningStatus: true,

    };
  },

   computed: {
    ...todoComputed,
    /**
     * Total no. of records
     */
    rows() {
      return this.tableData.length;
    },

    /**
     * Todo list of records
     */
    todoList() {
      return this.todos.length;
    },
  },

  mounted() {

    axios.get("https://bdd7w9ysj6.execute-api.us-west-1.amazonaws.com/app/usuarios?id_empresa=1&id_tipo=1&id_municipio=1").then((response) => {
    this.response = response.data.data;
    this.tableContacts = response.data.data;
     console.log(response)
  })
    this.fetchTodos();
    // Set the initial number of items
    this.totalRows = this.tableData.length;
    this.todoTotalRows = this.todos.length
    setTimeout(() => {
      this.showModal = true;
    }, 1500);
  },

    methods: {
    ...todoMethods,

      myFunction() {
  // Declare variables
  var input, filter, table, tr, td, i, txtValue;
  input = document.getElementById("myInput");
  filter = input.value.toUpperCase();
  table = document.getElementById("myTable");
  tr = table.getElementsByTagName("tr");

  // Loop through all table rows, and hide those who don't match the search query
  for (i = 0; i < tr.length; i++) {
    td = tr[i].getElementsByTagName("td")[0];
    if (td) {
      txtValue = td.textContent || td.innerText;
      if (txtValue.toUpperCase().indexOf(filter) > -1) {
        tr[i].style.display = "";
      } else {
        tr[i].style.display = "none";
      }
    }
  }
},

    /**
     * Search the table data with search input
     */
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },

    todoFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.todoTotalRows = filteredItems.length;
      this.todocurrentPage = 1;
    },

    getColor (estado) {
        if (estado == "Activo") return 'red'
        else return 'green'
      },

    handleInput(value, data) {
      this.editableDataItems[data.index][data.field.key] = value;
    }
    
  },


};
</script>
<template>
  <Layout>
  <PageHeader :title="title" :items="items" />
  <v-row>
     <v-col md="12">
      <v-card>
        <div class="card-body">
          <v-row>
            <v-col md="7">
              <h4 class="card-title mb-4">Contactos</h4>
            </v-col>
          </v-row>

          <v-row>
            <v-col md="6">
              <div id="tickets-table_length" class="dataTables_length">
                <label class="d-inline-flex align-items-center">
                  Ver 
                  <v-divider
                    class="mx-1"
                    inset
                    vertical
                  ></v-divider>
                  <b-form-select
                    class="form-select form-select-sm"
                    v-model="perPage"
                    size="sm"
                    :options="pageOptions"
                  ></b-form-select>
                  <v-divider
                    class="mx-1"
                    inset
                    vertical
                  ></v-divider>
                    registros
                </label>
              </div>
            </v-col>
            <!-- Search -->
            
            <v-col md="6">
              <div
                id="tickets-table_filter"
                class="dataTables_filter text-md-end"
              >
              <label class="d-inline-flex align-items-center">
                Buscar:
                <b-form-input
                  v-model="filters.total.value"
                  id="myInput" 
                  onkeyup="myFunction()"
                  type="search"
                  laceholder="Buscar..."
                  class="form-control form-control-sm ms-2 "
                ></b-form-input>
              </label>
              </div>
            </v-col>
            <!-- End search -->

            <!-- tableContacts table -->
            <tableContacts
              :filters="filters"
              :tableContacts="tableContacts"
              :updating="fetchingStats"
              :id="myTable"
              responsive="sm"
              :per-page="perPage"
              :current-page="current"
              :sort-by.sync="sortBy"
              :sort-desc.sync="sortD"
              :filter="filter"
              :filter-included-fields="filterOn"
              @filtered="onFiltered"
            />
            <v-col md="6">
              <v-divider
                class="mx-2"
                inset
                vertical
              ></v-divider>
              Mostrando {{currentPage}} de {{totalRows}}  registros
            </v-col>
            <v-col md="6">
            <b-pagination
              v-model="currentPage"
              :total-rows="rows"
              :per-page="perPage"
              first-text="Primera"
              prev-text="Anterior"
              next-text="Siguiente"
              last-text="Última"
            ></b-pagination>
            </v-col>
          </v-row>
        </div>
      </v-card>
    </v-col>
   <!-- end col -->
  </v-row>
 <!-- end row -->
</Layout>
</template>
